<template>
  <section class="qv-card qv-tabs-card">
    <p class="qv-section-title network-title">
      Compras &amp; Estoque na Rede
    </p>

    <a-tabs v-model="activeTab" size="small" class="qv-tabs">
      <a-tab-pane key="compras" tab="Compras">
        <div class="qv-sk-table" v-if="loading">
          <div class="qv-sk-table-row qv-sk-table-head">
            <span class="qv-sk qv-sk-cell" style="width: 25%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
          </div>
          <div class="qv-sk-table-row" v-for="n in 5" :key="'compras-' + n">
            <span class="qv-sk qv-sk-cell" style="width: 25%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 15%;"></span>
          </div>
        </div>

        <div v-else class="qv-table-scroll">
          <a-table
            :columns="purchaseColumns"
            :data-source="purchases"
            :pagination="false"
            :row-key="(row, index) => row.key || index"
            size="small"
            class="qv-table"
          />
        </div>
      </a-tab-pane>

      <a-tab-pane key="vendas" tab="Vendas">
        <div class="qv-sk-table" v-if="loading">
          <div class="qv-sk-table-row qv-sk-table-head">
            <span class="qv-sk qv-sk-cell" style="width: 40%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 30%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 30%;"></span>
          </div>
          <div class="qv-sk-table-row" v-for="n in 5" :key="'vendas-' + n">
            <span class="qv-sk qv-sk-cell" style="width: 40%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 30%;"></span>
            <span class="qv-sk qv-sk-cell" style="width: 30%;"></span>
          </div>
        </div>

        <div v-else class="qv-table-scroll">
          <a-table
            :columns="salesColumns"
            :data-source="networkSales"
            :pagination="false"
            :row-key="row => row.key"
            size="small"
            class="qv-table"
          >
            <template slot="giro" slot-scope="value, record">
              <qv-giro-sparkline
                :value="value"
                :periods="record.giroPeriods"
                :tendency="record.tendency"
              />
            </template>

            <template slot="footer">
              <div class="qv-sales-total">
                <span>Total da rede</span>
                <strong>{{ networkTotal.average }}</strong>
                <strong>{{ networkTotal.total }}</strong>
              </div>
            </template>
          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="grafico" tab="Comparativo">
        <div class="qv-chart-legend">
          <span class="legend-item">
            <span class="legend-color sales"></span>
            Vendas (qtd)
          </span>

          <span class="legend-item">
            <span class="legend-color purchases"></span>
            Compras (qtd)
          </span>
        </div>

        <div class="qv-sk qv-sk-chart" v-if="loading"></div>

        <highcharts
          v-else
          :options="chartOptions"
          class="qv-chart"
        />
      </a-tab-pane>

      <a-tab-pane key="estoque" tab="Estoque">
        <div class="qv-store-table">
          <div class="qv-store-row qv-store-header">
            <span class="store-name">Loja</span>
            <span class="store-status">Status</span>
            <span class="store-cov">Cobertura</span>
            <span class="store-est">Estoque</span>
            <span class="store-est">Est. Estimado</span>
          </div>

          <template v-if="loading">
            <div class="qv-store-row" v-for="n in 4" :key="'estoque-' + n">
              <span class="store-name"><span class="qv-sk" style="width: 60%; height: 12.35px;"></span></span>
              <span class="store-status"><span class="qv-sk" style="width: 70%; height: 18px; border-radius: 10px;"></span></span>
              <span class="store-cov"><span class="qv-sk" style="width: 70%; height: 12.35px; margin-left: auto;"></span></span>
              <span class="store-est"><span class="qv-sk" style="width: 70%; height: 12.35px; margin-left: auto;"></span></span>
              <span class="store-est"><span class="qv-sk" style="width: 70%; height: 12.35px; margin-left: auto;"></span></span>
            </div>
          </template>

          <div
            v-else
            v-for="store in diagnosticsStores"
            :key="store.key"
            class="qv-store-row"
          >
            <span class="store-name">
              {{ store.name }}
              <span v-if="store.current" class="atual">atual</span>
            </span>

            <span
              class="status"
              :style="{
                background: getStockStatus(store.status).bg,
                color: getStockStatus(store.status).color,
                borderColor: getStockStatus(store.status).color
              }"
            >
              <span
                class="dot"
                :style="{ background: getStockStatus(store.status).color }"
              ></span>
              {{ getStockStatus(store.status).label }}
            </span>

            <span class="store-cov">{{ store.coverage }}</span>

            <span class="store-est">
              {{ store.stock | stock }}
              <span class="u">un</span>
            </span>

            <span class="store-est">
              {{ store.estimated }}
              <span class="u">un</span>
            </span>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </section>
</template>

<script>
import Highcharts from 'highcharts';
import { Chart } from 'highcharts-vue';
import { getStockStatus } from './stockStatus';
import QvGiroSparkline from './_qv-giro-sparkline.vue';

function formatDate(value) {
    if (!value) {
        return '';
    }

    const raw = String(value).substring(0, 10);
    const [year, month, day] = raw.split('-');

    if (!year || !month || !day) {
        return '';
    }

    return `${day}/${month}/${year}`;
}

function formatCurrency(value) {
    return Number(value || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}

export default {
    name: 'QvTabs',

    components: {
        highcharts: Chart,
        QvGiroSparkline,
    },

    props: {
        loading: {
            type: Boolean,
            default: false,
        },

        purchases: {
            type: Array,
            default: () => [],
        },

        networkSales: {
            type: Array,
            default: () => [],
        },

        networkTotal: {
            type: Object,
            default: () => ({
                average: 0,
                total: 0,
            }),
        },

        salesPoints: {
            type: Array,
            default: () => [],
        },

        purchasePoints: {
            type: Array,
            default: () => [],
        },

        diagnosticsStores: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            activeTab: 'compras',
        };
    },

    computed: {
        chartOptions() {
            return {
                chart: {
                    type: 'line',
                    height: 220,
                    backgroundColor: 'transparent',
                    margin: [10, 10, 30, 10],
                },

                title: {
                    text: null,
                },

                credits: {
                    enabled: false,
                },

                legend: {
                    enabled: false,
                },

                xAxis: {
                    type: 'datetime',

                    labels: {
                        format: '{value:%d/%m}',
                        style: {
                            fontSize: '10px',
                        },
                    },

                    tickLength: 0,
                    lineWidth: 0,
                },

                yAxis: [
                    {
                        title: {
                            text: null,
                        },
                        labels: {
                            enabled: false,
                        },
                        gridLineWidth: 1,
                        tickAmount: 3,
                        min: 0,
                    },
                    {
                        title: {
                            text: null,
                        },
                        labels: {
                            enabled: false,
                        },
                        gridLineWidth: 0,
                        tickAmount: 3,
                        min: 0,
                        opposite: true,
                    },
                ],

                tooltip: {
                    shared: true,
                    useHTML: true,
                    formatter() {
                        const date = Highcharts.dateFormat(
                            '%d/%m/%Y',
                            this.x
                        );

                        let html = `<b>${date}</b>`;

                        this.points.forEach(point => {
                            html += `
                                <br>
                                <span style="
                                    display:inline-block;
                                    width:7px;
                                    height:7px;
                                    border-radius:50%;
                                    background:${point.color};
                                    margin-right:5px;
                                "></span>
                                ${point.series.name}: <b>${point.y}</b>
                            `;
                        });

                        return html;
                    },
                },

                plotOptions: {
                    series: {
                        marker: {
                            enabled: true,
                            radius: 3,
                        },
                        lineWidth: 2,
                    },
                },

                series: [
                    {
                        name: 'Vendas',
                        type: 'line',
                        color: '#52c41a',
                        yAxis: 0,
                        data: this.salesPoints.map(point => [
                            new Date(point.date).getTime(),
                            point.value,
                        ]),
                    },
                    {
                        name: 'Compras',
                        type: 'line',
                        color: '#f5222d',
                        yAxis: 1,
                        data: this.purchasePoints.map(point => [
                            new Date(point.date).getTime(),
                            point.value,
                        ]),
                    },
                ],
            };
        },

        purchaseColumns() {
            return [
                { title: 'Fornecedor', dataIndex: 'supplier', key: 'supplier' },
                {
                    title: 'Data',
                    dataIndex: 'date',
                    key: 'date',
                    customRender: (value) => formatDate(value),
                },
                {
                    title: 'Qtd. Emb.',
                    dataIndex: 'packages',
                    key: 'packages',
                    align: 'right',
                    customRender: (value) => Number(value || 0).toFixed(0),
                },
                {
                    title: 'Qtd.',
                    dataIndex: 'quantity',
                    key: 'quantity',
                    align: 'right',
                    customRender: (value) => Number(value || 0).toFixed(0),
                },
                {
                    title: 'Val. Unit.',
                    dataIndex: 'unitValue',
                    key: 'unitValue',
                    align: 'right',
                    customRender: (value) => formatCurrency(value),
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    customRender: (value) => formatCurrency(value),
                },
            ];
        },

        salesColumns() {
            return [
                {
                    title: 'Loja',
                    dataIndex: 'store',
                    key: 'store',
                },
                {
                    title: 'Giro Médio',
                    dataIndex: 'average',
                    key: 'average',
                    align: 'right',
                    scopedSlots: { customRender: 'giro' },
                },
                {
                    title: 'Qtd. Total (30d)',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    customRender: (value) => `${Number(value || 0).toFixed(0)} un`,
                },
            ];
        },
    },

    methods: {
        getStockStatus,
    },
};
</script>

<style lang="scss" scoped>
@import './_qv-shared.scss';

.qv-tabs-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}

.qv-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.qv-tabs ::v-deep .ant-tabs-content {
  flex: 1;
  min-height: 0;
}

.qv-tabs ::v-deep .ant-tabs-tabpane-active {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.qv-table-scroll {
  flex: 1;
  min-height: 0;
  max-height: calc(100vh - 460px);
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.qv-table-scroll ::v-deep .ant-table-small {
  border: 0;
  border-radius: 0;
}

.qv-table-scroll ::v-deep .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}

.qv-table-scroll ::v-deep .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 8px 10px !important;
  background-color: #fafafa;
  font-weight: 700;
  border-bottom-color: var(--border);
}

.qv-table-scroll ::v-deep .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
  padding: 8px 10px;
  border-bottom-color: var(--border);
}

.qv-table-scroll ::v-deep .ant-table-small > .ant-table-content > .ant-table-footer {
  position: sticky;
  bottom: 0;
  z-index: 1;
  padding: 0;
  border-top: 0;
  background-color: #fff;
}

.network-title {
  margin-bottom: 10px;
}

.qv-sk-chart {
  height: 220px; // matches chartOptions.chart.height
  border-radius: 8px;
}

.qv-sk-table {
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
}

.qv-sk-table-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
}

.qv-sk-table-row:last-child {
  border-bottom: none;
}

.qv-sk-table-head {
  background: #fafafa;
}

.qv-sk-cell {
  height: 12px;
}

.qv-sk-table-head .qv-sk-cell {
  height: 8px;
}

.qv-tabs ::v-deep .ant-tabs-bar {
  flex-shrink: 0;
  margin-bottom: 2px;
}

.qv-tabs ::v-deep .ant-tabs-tab {
  padding: 2px 5px;
  font-size: 12px;
  font-weight: 600;
  margin: 0 6px 0 6px;
}

.qv-tabs ::v-deep .ant-tabs-tab-active {
  color: var(--brand-deep);
}

.qv-tabs ::v-deep .ant-tabs-ink-bar {
  background: var(--brand);
}

.qv-sales-total {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 8px;
  padding: 8px 10px;
  border-top: 1px solid var(--border-strong);
  font-size: 11px;
  color: var(--text);
}

.qv-sales-total strong {
  font-weight: 700;
  text-align: right;
}

.qv-chart-legend {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 10px;
  font-size: 11.5px;
  color: var(--text-2);
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.legend-color {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
}

.legend-color.sales {
  background: var(--success);
}

.legend-color.purchases {
  background: var(--danger);
}

.qv-chart {
  display: block;
  overflow: visible;
}

.qv-store-table {
  flex: 1;
  min-height: 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  max-height: calc(100vh - 460px);
  overflow-y: auto;
}


.qv-store-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
}

.qv-store-row:last-child {
  border-bottom: none;
}

.qv-store-header {
  background: #fafafa;
  position: sticky;
  top: 0;
  z-index: 1;
}

.qv-store-header .store-name,
.qv-store-header .store-status,
.qv-store-header .store-cov,
.qv-store-header .store-est {
  font-size: 9.5px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: var(--text-3);
  font-weight: 700;
}

.store-name {
  flex: 1;
  min-width: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text);
}

.store-name .atual {
  font-size: 9px;
  font-weight: 700;
  color: var(--brand-deep);
  background: var(--brand-soft);
  border-radius: 8px;
  padding: 1px 6px;
  margin-left: 6px;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

.store-status {
  min-width: 60px;
  flex-shrink: 0;
}

.store-cov {
  min-width: 56px;
  text-align: right;
  font-size: 11px;
  color: var(--text-3);
  font-variant-numeric: tabular-nums;
}

.store-est {
  min-width: 64px;
  text-align: right;
  font-size: 13px;
  font-weight: 700;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.store-est .u {
  font-size: 10px;
  font-weight: 500;
  color: var(--text-3);
  margin-left: 2px;
}
</style>
